import { SearchProducts } from "@nosto/nosto-js/client"
import Button from "@/elements/Button/Button"
import Product from "@/components/Autocomplete/Item/Product"
import styles from "./Results.module.css"
import { useOnSubmit } from "../OnSubmitContext"

export type ProductsProps = {
  products: SearchProducts
  input: string
  showSeeAll?: boolean
}

export default function Products({ products, input, showSeeAll = true }: ProductsProps) {
  const onSubmit = useOnSubmit()

  if (!products?.hits?.length) {
    return null
  }

  return (
    <div className={styles.productsColumn}>
      <div className={styles.products}>
        {products.hits.map(hit => (
          <Product key={hit.productId} hit={hit} />
        ))}
      </div>
      {showSeeAll && (
        <div className={styles.button}>
          <Button type="button" className={styles.submit} onClick={() => onSubmit(input)}>
            See all {products.total} Results
          </Button>
        </div>
      )}
    </div>
  )
}
